/**
 * 自 warehouse select options 取 label（與下拉顯示一致）。
 *
 * @param {{ value?: string, label?: string }[]} [options]
 * @param {string} [id]
 * @returns {string}
 */
export function warehouseLabelById(options = [], id) {
  if (!id) {
    return '所選倉別';
  }
  const match = options.find((option) => option?.value === id);
  const label = match?.label;
  if (label == null || label === '') {
    return '所選倉別';
  }
  return String(label);
}
